// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';



class AddCredit extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      customer_search_list: [],
      customer_details: {
        mobile_no: '',
        name: '',
        id: '',
        display_name:'',
      },
      reasons: [],
      reason: null,
      comment: null,
      reference_objects: [],
      reference_object: null,
      file : null,
      amount: 0,
      credit_balance: 0,
      credit_history:[],
     
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.fetchReferenceObjects = this.fetchReferenceObjects.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.post_give_credit_bulk = this.post_give_credit_bulk.bind(this);
    this.fileHandler = this.fileHandler.bind(this);
    this.getCreditHistory =this.getCreditHistory.bind(this);
    this.creditHistoryView = this.creditHistoryView.bind(this);

  }


  componentDidMount() {
    this.getDetailsForAddCredit();
    

    // // TODO: remove after testing
    // this.setPostSubscriptions();
  }


  getDetailsForAddCredit() {
     const url = `${getLocationOrigin()}/sporthoodcreditadmin/get_details_for_add_credit/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({reasons: data.reasons, reason:data.reasons[0] });
           // this.setState({reason:data.reasons[0]})

       }).catch(error => error);
  }

  getCreditHistory() {
    var mob =this.state.customer_details.display_name.split(":");
    var url = `${getLocationOrigin()}/sporthoodcreditadmin/credit_history_for_customer/?`;
    url = (url + "&mobile_no="+ mob[1])
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({credit_history: data.credit_history });

       }).catch(error => error);  

  }

  creditHistoryView(event){
    this.getCreditHistory();
    
  }

  fetchReferenceObjects(reason){
    var mob =this.state.customer_details.display_name.split(":");
    var url = `${getLocationOrigin()}/sporthoodcreditadmin/get_reference_objects_for_reason_code/?`;
    url = (url + "reason=" + reason[0])
    url = (url + "&mobile_no="+ mob[1])
    url = (url + "&customer_id=" + this.state.customer_details.id)
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({reference_objects: data.objects ,reference_object:data.objects[0].id});

       }).catch(error => error);    
  }


  

  

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_search_list: data.results, search: true , credit_balance:data.credit_balance}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }


  postAddCredits(data) {


    const url = `${getLocationOrigin()}/sporthoodcreditadmin/addCreditlog/`;
                const options = {...defaultOptions};
                options['method'] = 'post';
                options['headers'] = {'content-type': 'application/json'}
                options['body'] = JSON.stringify({
                    'user': data.customer_details.mobile_no,
                    'amount':data.amount,
                    'reason':data.reason[0],
                    'object':data.reference_object,
                    'description':data.comment,
                });
                console.log('Going to fetch');
                return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then((response) => {
                    console.log(response)                   
                    alert(response['message']); 
                                      
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                });


    
    
  }

  post_give_credit_bulk(){
    const url = `${getLocationOrigin()}/sporthoodcreditadmin/addCreditlogbulk/`;
                const options = {...defaultOptions};
                var formData = new FormData();
                formData.append('file', this.state.file);
                options['method'] = 'post';
                options['body'] = formData;
                console.log('Going to fetch');
                return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then((response) => {
                    console.log(response)                   
                    alert(response['success_count']+" Credits given and "+response['unmatch_count'] +" unmatched and "+response['fail_count']+" duplicate Credit found\nduplicate list are as follows\n"+response['fail_list']
                      +"and unmatched list as\n"+response['unmatch_list']);                    
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                });
  }

  fileHandler = (event) => {
    let fileObj = event.target.files[0];
    this.setState({file :fileObj});
  }

  
  


  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.customer_details);
    var new_state = Object.assign({}, this.state);

    if (name=="display_name"){
        var temp_no = event.target.value.split(":");
        if (temp_no.length == 2){
             temp_no = temp_no.pop();
            if(temp_no.length != 10){
                new_selected_one[name] = temp_no;
                new_selected_one["mobile_no"] = "";
                new_selected_one["name"] = "";
                new_selected_one["id"] = "";
            }
            else{
                new_selected_one[name] = event.target.value
            }
        }
        else{
            new_selected_one[name] = event.target.value
        }
        this.setState({credit_history:null,credit_balance:0});
    }
    else if (name =='reference_object'){
          console.log("reference_object changed");
          console.log("Fetch the objects");
          this.setState({reference_object:event.target.value});
    }
    else{
        new_state[name] = event.target.value
        this.setState(new_state);
        if(name=='reason'){
          console.log("Reason changed");
          console.log("Fetch the objects");
          this.fetchReferenceObjects(event.target.value);
        }

    }



    this.setState({customer_details: new_selected_one}, () => {
        if (name=="venue" || name=="game_type"){
            var new_selected_one =  Object.assign({}, this.state.customer_details);
            new_selected_one["package"] = "";
            this.setState({customer_details: new_selected_one}, ()=>this.getPackageList());
        }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postAddCredits(this.state);    
    console.log('post');
    console.log(this.state);
    event.preventDefault();
    
  }

  

  searchCustomer() {
    {this.state.customer_details.display_name?this.getSearchList(this.state.customer_details.display_name):
      alert('Search cannot be blank')}
  }

  setSearch(name, mobile, id){
    var new_selected_one =  Object.assign({}, this.state.customer_details);
    new_selected_one['mobile_no'] = mobile;
    new_selected_one['name'] = name;
    new_selected_one['id'] = id;
    new_selected_one['display_name'] = `${name}:${mobile}`;
    this.setState({customer_details: new_selected_one, search: false}, () =>{
        this.setCart(id);
    });
  }

  handleDate(date, event, name){
    var new_selected_one =  {};
    new_selected_one[name] = date;
    this.setState(new_selected_one);
  }

  

  

  

  render() {
    console.log('render')
    console.log(this.state.reference_object)    
    console.log(this.state.amount)
    console.log(this.state.reason)
    console.log(this.state.credit_history)

    return(
      <div style={{...styles.container}}>
        
            <div className="row col-md-8 table-bordered" style={styles.table}>
              <div style={styles.main_header} className="col-md-12">
                <h3 style={{textAlign:'center'}}>Add Credit</h3>
              </div>
              <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Customer
                  </div>
                  <div className="col-md-8 input-group">
                    <input type="text" name="display_name" className="form-control"
                      placeholder="Search for.. " value={this.state.customer_details.display_name}
                      data-customerId={this.state.customer_details.id}
                      onChange={this.handleChange}/>
                    <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.searchCustomer}></button>
                    </span>
                  </div>
                </div>
                {this.state.search?
                  <div className="col-md-12 btn-group">
                    {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.mobile_no,x.id)}>{x.name}:{x.mobile_no}</button>))
                :<div className="alert alert-danger">Search customer not found</div>}</div>:''}
                
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-4">
                     Credit Balance: 
                    </div>
                    <div style={styles.item_header} className="col-md-4">
                     {this.state.credit_balance}
                    </div>
                    <div style={styles.item_header} className="col-md-4">
                     <span onClick={this.getCreditHistory} style={{padding:'1px 5px',background: '#32b6a7', border: '1px solid #ddd', margin: '1px'}}>View History </span>
                  </div>
                </div>
                {
                  this.state.credit_history &&
                  <div className="col-md-12">
                    {this.state.credit_history.map( (x) =>(
                      <div className="col-md-12"
                    style={{padding:'1%',background: '#ccc', border: '1px solid #ddd', margin: '1px'}} >
                    Rs:{x.amount} on  {moment(x.created_on).format('DD MMM, YYYY')} ( {x.reason} ) , {x.description}</div>))
                  }
                </div>
              }
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-4">
                     Amount
                    </div>
                    <input type="text" name="amount" className="col-md-8" value={this.state.amount} onChange={this.handleChange}/>
                </div>
                
                
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Reason
                  </div>
                  <select name="reason" className="col-md-8" style={styles.item_body} value={this.state.reason}
                    onChange={this.handleChange}>
                    {
                      this.state.reasons.map((x, index) => (
                      <option value={x} key={x[0]}>{`${x[1]}`}</option>

                      ))
                    }
                  </select>
                </div>
                


                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Reference Object
                  </div>
                  <select name="reference_object" className="col-md-8" style={styles.item_body} value={this.state.reference_object}
                    onChange={this.handleChange}>
                    {
                      this.state.reference_objects.map((x, index) => (
                      <option key={x.id} value={x.id} >{`${x.name}`}</option>
                      ))
                    }
                  </select>
                </div>  
                
                
                

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-4">
                     Comment
                    </div>
                    <input type="text" name="comment" className="col-md-8" value={this.state.comment} onChange={this.handleChange}/>
                </div>

                <div style={{
                    ...styles.items,
                    "borderBottom": "1px dashed",
                    "marginBottom": "1em",
                    "paddingBottom": "1.5em",
                }} className="col-md-12">
                <div style={styles.button_submit} className="col-md-12">
                  <input className="btn btn-lg"  type="submit" value="Give Credit" style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>

                </div>

                </div>

                <div style={styles.button_submit} className="col-md-12">
                  
                  <input type="file" onChange={this.fileHandler.bind(this)} style={{"padding":"10px"}} />
                  
                  <input className="btn btn-lg" onClick={this.post_give_credit_bulk} type="button" value="Give Bulk Credit" style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>


                </div>
              </form>
            </div>
        
          
        
      </div>
    );
  }
}

export default AddCredit;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/add_credit/index.js